import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import brandTheme from "brandTheme/Theme";
const useStyles = makeStyles((theme) => ({
  sectionWrapper: {
    width: "100%",
  },

  sectionTitle: {
    textAlign: "center",
    fontWeight: 700,
    marginBottom: 24,
    color: "#0F1F4B",
  },

  documentGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: 16,

    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: 12,
    },
  },

  documentCard: {
    background: "#fff",
    border: "1px solid #E8EAF0",
    borderRadius: 12,
    padding: "20px 12px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 120,
    transition: "all .2s ease",

    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    },
  },

  documentIcon: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    background: brandTheme.backgroundColor,
    color: brandTheme.mainColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 12,

    "& svg": {
      fontSize: 30,
      fill: brandTheme.secondaryColor,
    },
  },

  documentLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "#1F2937",
    textAlign: "center",
  },
}));

export const DocumentGrid = ({ title, items }) => {
      const classes = useStyles();
  return (
    <div className={classes.sectionWrapper}>
      <div className={classes.documentGrid}>
        {items.map((item, index) => (
          <div key={index} className={classes.documentCard}>
            <div className={classes.documentIcon}>
              {item.icon}
            </div>

            <Typography
              variant="body1"
              className={classes.documentLabel}
            >
              {item.label}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};